import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAuth } from '../context/AuthContext';
import PageLoader from './feedback/PageLoader';
import { isAdmin, canPerformWaiterActions, resolveStaffRoles } from '../utils/staffRoles';

export const ProtectedRoute = ({ children, requireAdmin = false, requireWaiter = false }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const authState = useSelector((state) => state.auth);
  const roles = resolveStaffRoles(authState);

  if (isLoading) {
    return <PageLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // Admin can access every protected admin route.
  if (isAdmin(roles)) {
    return children;
  }

  if (requireAdmin) {
    return <Navigate to="/admin/access-denied" replace />;
  }

  if (requireWaiter && !canPerformWaiterActions(roles)) {
    return <Navigate to="/admin/access-denied" replace />;
  }

  return children;
};
